import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const featureDeleteEndpoint = ApiEndpoints.featureService.featureServiceDelete;
const featureListEndpoint = ApiEndpoints.featureService.featureServiceList;
const featureEditPath = "edit-feature";



const tableHeader = ["Title",  "Brief" , "Blue Heading"];
const tbody = ["section1_title", "section1_brief" ,"section2_blue_heading"];

export default function FeatureService() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", featureListEndpoint);
      const result = response.features;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (feature_id) => {
    const payload = { feature_id };
    try {
      const response = await ApiRequest("POST", featureDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Feature Management',
    user: 'Admin',
    innerpage: 'Feature Management / Feature'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-feature">Add +</Link>
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} editPath={featureEditPath} onDelete={handleDelete} />
      </div>
    </>
  );
}



